module.exports = __webpack_public_path__ + "src/app/_content/MINIFonts/mini_serif-bold-web.woff?0641e10e0ffb07fa1f46ed46ec498845";